import type { SupportEmailConfig } from '@quipex/core/config';

export const SUPPORT_EMAIL_CONFIG = {
    recipient: 'support@quipex.au',
    subject: 'Quipex support request',
} as const satisfies SupportEmailConfig;
